export default __webpack_public_path__ + "static/media/columnoption_dark.e802cc20.svg";